// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import classnames from "classnames";
import LoadingBox from "./LoadingBox.jsx";
import {
	RTE_WRAPPER_CLASS,
	RTE_TOOLBAR_CLASS
} from "../../../../main/index.js";

/**
 * @param {Object}   props
 * @param {string}   props.id
 * @return {HTMLElement}
 */
const RichTextEditor = (props) => {
	const {
		id,
		isAnnotationNote = false
	} = props;

	// Prevent key events in the rich text editor from affecting other elements
	const onKeyDownShadow = (event) => {
		// Allow esc key events through so that tooltips can be dismissed
		if (event.key !== "Escape" && event.key !== "Esc")
			event.stopPropagation();
	};

	return <div
		className={classnames(RTE_WRAPPER_CLASS, {
			"pn-notes-wrapper": isAnnotationNote
		})}
		id={`${id}-wrapper`}
	>
		<div className="rich-text-editor-area" lang="">
			<LoadingBox  />
			<div
				className={classnames(`js-rte-${id}`, "rte-wrapper")}
				onKeyDown={onKeyDownShadow}
			></div>
		</div>

		<div className={RTE_TOOLBAR_CLASS} id={`${id}-toolbar`}></div>
	</div>;
};

export default RichTextEditor;
